import axios from 'axios'
import config from '../config/app'

const VERSION = '/v2'
const PATH = 'strategy-url'

const strategyDocumentAPI = {
  add (fields) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + VERSION + '/' + PATH, fields).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  get (fields) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + VERSION + '/' + PATH + '/get', fields).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  }
}

export default strategyDocumentAPI



// WEBPACK FOOTER //
// ./src/api/strategyUrl.js